/*
 * Die Einstellung „Zuständig für Skills4Retail-Anfragen" (Anforderung #216):
 * `{ assigneeId, projectId }`. Dieselbe Lesart wie `readTopicConfig` im
 * Backend (services/tickets/topic) — fehlt etwas, ist niemand eingetragen,
 * und die Anfrage geht den gewohnten Weg über das Bundesland.
 */
export const SKILLS4RETAIL_REQUESTS_OPTION = 'skills4RetailRequests'

const kennung = wert => {
	const zahl = Number(wert)
	return Number.isInteger(zahl) && zahl > 0 ? zahl : null
}

export const readSkills4RetailRequests = options => {
	const raw = options?.[SKILLS4RETAIL_REQUESTS_OPTION]
	const wert = raw && typeof raw === 'object' ? raw : {}
	return { assigneeId: kennung(wert.assigneeId), projectId: kennung(wert.projectId) }
}
